export function normalizeLanguageTag(language: string | null | undefined, fallback = 'es'): string {
  const raw = (language || '').trim();
  if (raw.length === 0) {
    return fallback;
  }

  return raw.toLowerCase().split('-')[0] || fallback;
}

